module.exports = __webpack_public_path__ + "img/20191231154815408.cdc2fc80.jpg";